var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.BtnClassList},[(_vm.btnConfig.isSelected)?[_c('div',{staticClass:"sort-select-btn__image-box"},[_c('div',{staticClass:"sort-select-btn__image",style:(_vm.imageStyleObject)})])]:[_c('div',{staticClass:"sort-select-btn__placeholder"},[_vm._v(_vm._s(_vm.btnConfig.text))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }